(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-shift-ai-root]';
  const STORAGE_KEY = 'shift_ai_funnel_session_v2';
  const OFFER_EXPIRY_KEY = 'shift_ai_funnel_offer_expiry_v1';

  const BASE_QUESTION = {
    key: 'target',
    prompt: 'Kit szeretnél bevonzani vagy közelebb hozni magadhoz?',
    options: [
      { value: 'ex', icon: '↩', label: 'Az exemet szeretném visszavonzani.', hint: 'Szakítás, csend, távolság vagy lezáratlan kötődés.' },
      { value: 'crush', icon: '♡', label: 'A kiszemeltemet szeretném bevonzani.', hint: 'Van valaki, akit szeretnél közelebb hozni.' },
      { value: 'partner', icon: '∞', label: 'A párommal szeretnék erősebb kapcsolódást.', hint: 'Meglévő kapcsolatban szeretnél több figyelmet, vágyat vagy mélységet.' },
      { value: 'stranger', icon: '✦', label: 'Valakit, akit még alig ismerek.', hint: 'Új vonzalom, kevés kontakt, bizonytalan indulás.' },
    ],
    allowCustom: false,
  };

  const GENDER_QUESTIONS = [
    {
      key: 'userGender',
      prompt: 'Te hogyan szeretnéd, hogy a Mentor megszólítson?',
      allowCustom: false,
      options: [
        { value: 'female', icon: '♀', label: 'Nőként', hint: 'A szöveg finoman ehhez igazodik.' },
        { value: 'male', icon: '♂', label: 'Férfiként', hint: 'A szöveg finoman ehhez igazodik.' },
        { value: 'other', icon: '○', label: 'Semlegesen / másként', hint: 'Nem használunk nemhez kötött megszólítást.' },
        { value: 'prefer_not', icon: '—', label: 'Nem szeretném megadni', hint: 'Maradunk teljesen semleges nyelvezetnél.' },
      ],
    },
    {
      key: 'targetGender',
      prompt: 'Milyen nemű az a személy, akit szeretnél bevonzani vagy visszavonzani?',
      allowCustom: false,
      options: [
        { value: 'male', icon: '♂', label: 'Férfi', hint: 'A kérdésekben férfiként hivatkozunk rá.' },
        { value: 'female', icon: '♀', label: 'Nő', hint: 'A kérdésekben nőként hivatkozunk rá.' },
        { value: 'other', icon: '○', label: 'Semlegesen fogalmazzunk', hint: 'Nem használunk nemhez kötött megnevezést.' },
        { value: 'unknown', icon: '—', label: 'Nem szeretném megadni', hint: 'Maradunk teljesen semleges nyelvezetnél.' },
      ],
    },
  ];

  const CUSTOM_OPTION_COPY = {
    situation: {
      label: 'Másképp írnám le.',
      hint: 'Ha egyik helyzet sem pontos, írd le saját szavaiddal.',
      placeholder: 'Írd le röviden, mi a pontos helyzet...'
    },
    pain: {
      label: 'Más fáj most a legjobban.',
      hint: 'Írd le, mi a valódi nehézség benned.',
      placeholder: 'Írd le röviden, mi a legnehezebb most...'
    },
    pattern: {
      label: 'Más mintát érzek.',
      hint: 'Ha más történik benned, írd le saját szavaiddal.',
      placeholder: 'Írd le röviden, milyen minta ismerős most...'
    },
    goal: {
      label: 'Más eredményre vágyom.',
      hint: 'Írd le, mit szeretnél elsőként megélni.',
      placeholder: 'Írd le röviden, mire vágysz most a legjobban...'
    },
  };

  const QUESTION_BRANCHES = {
    ex: [
      {
        key: 'situation',
        prompt: 'Mi írja le legjobban a mostani helyzetet az exeddel?',
        options: [
          { value: 'no_contact', icon: '○', label: 'Nincs kontakt köztünk.', hint: 'Csend van, de te még erősen kötődsz hozzá.' },
          { value: 'mixed_signals', icon: '〰', label: 'Vegyes jeleket ad.', hint: 'Néha közelít, aztán eltűnik vagy bezár.' },
          { value: 'blocked', icon: '⛔', label: 'Letiltott vagy nagyon eltávolodott.', hint: 'Most úgy érzed, nincs valódi hozzáférésed.' },
          { value: 'third_party', icon: '👤', label: 'Félek, hogy valaki más is van.', hint: 'Ez felerősíti a sürgetést és a bizonytalanságot.' },
        ],
      },
      {
        key: 'pain',
        prompt: 'Mi fáj most a legjobban az exeddel kapcsolatban?',
        options: [
          { value: 'waiting', icon: '💬', label: 'Várom, hogy írjon vagy keressen.', hint: 'A csend és a bizonytalanság irányít.' },
          { value: 'mind_loop', icon: '🌀', label: 'Nem tudom kiverni a fejemből.', hint: 'Újra és újra ő jár a gondolataidban.' },
          { value: 'fear_loss', icon: '⚡', label: 'Félek, hogy végleg elveszítem.', hint: 'A veszteségtől való félelem vezet.' },
          { value: 'worth', icon: '🌹', label: 'Szeretném újra fontosnak érezni magam.', hint: 'Nem csak ő hiányzik, hanem a választottság érzése is.' },
        ],
      },
      {
        key: 'pattern',
        prompt: 'Őszintén: ha most nem fognád vissza magad, mit tennél?',
        options: [
          { value: 'write', icon: '✉', label: 'Ráírnék, hogy tisztázzuk.', hint: 'Azonnali választ és megnyugvást keresel.' },
          { value: 'check', icon: '👁', label: 'Figyelném, mit csinál.', hint: 'Online állapot, posztok, jelek, apró mozdulatok.' },
          { value: 'explain', icon: '📝', label: 'Elmagyaráznám, mennyire fontos.', hint: 'Szeretnéd, hogy végre megértse, mit veszít.' },
          { value: 'pullback', icon: '🕯', label: 'Visszahúzódnék, de nehéz.', hint: 'Érzed, hogy tér kellene, de félsz tőle.' },
        ],
      },
      {
        key: 'goal',
        prompt: 'Melyik eredményre vágysz a legmélyebben?',
        options: [
          { value: 'remember', icon: '✦', label: 'Újra eszébe jussak.', hint: 'Ne tudjon olyan könnyen elfelejteni.' },
          { value: 'miss', icon: '☾', label: 'Hiányozzak neki.', hint: 'Érezze meg, hogy nélküled más lett a tér.' },
          { value: 'desire', icon: '♡', label: 'Újra akarjon engem.', hint: 'Ne csak emlék legyél, hanem vágy és húzás.' },
          { value: 'return', icon: '↩', label: 'Keressen vagy közeledjen.', hint: 'Az első jel, hogy még van köztetek valami.' },
        ],
      },
    ],
    crush: [
      {
        key: 'situation',
        prompt: 'Mennyire van most kapcsolat köztetek a kiszemelteddel?',
        options: [
          { value: 'barely', icon: '👀', label: 'Csak látásból ismerem.', hint: 'Észrevétel, első benyomás és jelenlét számít.' },
          { value: 'same_circle', icon: '⭕', label: 'Egy közegben mozgunk.', hint: 'Látjátok egymást, de nincs igazi közeledés.' },
          { value: 'chatting', icon: '💬', label: 'Beszélünk néha.', hint: 'Van kontakt, de nem elég erős vagy egyértelmű.' },
          { value: 'friends', icon: '🤍', label: 'Baráti / ismerősi helyzetben vagyunk.', hint: 'Szeretnéd, hogy más szemmel nézzen rád.' },
        ],
      },
      {
        key: 'pain',
        prompt: 'Mi a legnehezebb most a kiszemelteddel kapcsolatban?',
        options: [
          { value: 'notice', icon: '✨', label: 'Szeretném, hogy észrevegyen.', hint: 'Még nem érzed, hogy igazán látna téged.' },
          { value: 'uncertainty', icon: '?', label: 'Nem tudom, mit érez.', hint: 'Vannak jelek, de nem egyértelműek.' },
          { value: 'fear', icon: '⚡', label: 'Félek kezdeményezni.', hint: 'Nem akarsz túl soknak vagy kínosnak tűnni.' },
          { value: 'competition', icon: '👤', label: 'Félek, hogy más is tetszik neki.', hint: 'Ez sürgetést és bizonytalanságot hoz.' },
        ],
      },
      {
        key: 'pattern',
        prompt: 'Milyen hatást szeretnél kelteni benne?',
        options: [
          { value: 'mystery', icon: '☾', label: 'Titokzatosabb szeretnék lenni.', hint: 'Ne legyen minden azonnal egyértelmű rólad.' },
          { value: 'magnetic', icon: '✦', label: 'Mágnesesebb jelenlétet szeretnék.', hint: 'Hogy észrevegyen és újra rád figyeljen.' },
          { value: 'soft', icon: '♡', label: 'Finomabb, erősebb vonzást szeretnék.', hint: 'Nem erőltetve, hanem természetesen hatni.' },
          { value: 'confident', icon: '∞', label: 'Magabiztosabbnak akarok hatni.', hint: 'Ne a félelem, hanem belső erő vezessen.' },
        ],
      },
      {
        key: 'goal',
        prompt: 'Mit szeretnél, mi történjen először?',
        options: [
          { value: 'notice_me', icon: '👁', label: 'Vegyen észre igazán.', hint: 'Ne csak háttérszereplő legyél.' },
          { value: 'message', icon: '💬', label: 'Írjon vagy keressen.', hint: 'Szeretnéd, hogy ő is mozduljon.' },
          { value: 'curious', icon: '?', label: 'Legyen kíváncsi rám.', hint: 'Újra és újra felmerülj benne.' },
          { value: 'closer', icon: '♡', label: 'Kerüljünk közelebb.', hint: 'Legyen több valódi kapcsolódás.' },
        ],
      },
    ],
    partner: [
      {
        key: 'situation',
        prompt: 'Mi írja le legjobban a mostani kapcsolatotokat?',
        options: [
          { value: 'distant', icon: '🌙', label: 'Eltávolodtunk egymástól.', hint: 'Kevesebb figyelem, melegség vagy jelenlét.' },
          { value: 'routine', icon: '∞', label: 'Rutinná vált a kapcsolat.', hint: 'Megvan a kapcsolat, de hiányzik a szikra.' },
          { value: 'conflict', icon: '⚡', label: 'Sok a feszültség.', hint: 'Veszekedések, sértettség vagy visszahúzódás.' },
          { value: 'desire_low', icon: '♡', label: 'Kevesebb a vágy.', hint: 'Szeretnéd újra felébreszteni a vonzalmat.' },
        ],
      },
      {
        key: 'pain',
        prompt: 'Mi hiányzik most legjobban a kapcsolatból?',
        options: [
          { value: 'attention', icon: '👁', label: 'A figyelme.', hint: 'Szeretnéd, hogy újra fontosnak érezd magad.' },
          { value: 'desire', icon: '🔥', label: 'A vágy és szenvedély.', hint: 'Több húzás, több érintés, több kívánás.' },
          { value: 'security', icon: '🕯', label: 'Az érzelmi biztonság.', hint: 'Szeretnéd, hogy stabilabbnak érezd a kötődést.' },
          { value: 'communication', icon: '💬', label: 'Az őszinte kommunikáció.', hint: 'Ne csak egymás mellett legyetek, hanem kapcsolódjatok.' },
        ],
      },
      {
        key: 'pattern',
        prompt: 'Melyik minta ismerős most leginkább?',
        options: [
          { value: 'overgive', icon: '↻', label: 'Túl sokat adok.', hint: 'Te tartod össze, te figyelsz, te alkalmazkodsz.' },
          { value: 'withdraw', icon: '○', label: 'Visszahúzódtam.', hint: 'Fáj, ezért bezársz vagy távolságot tartasz.' },
          { value: 'needy', icon: '⚡', label: 'Túl erősen várom a reakcióját.', hint: 'A figyelme határozza meg a hangulatod.' },
          { value: 'resentment', icon: '☁', label: 'Sok bennem a sértettség.', hint: 'Szeretnél közelebb lenni, de nehéz oldódni.' },
        ],
      },
      {
        key: 'goal',
        prompt: 'Mi lenne most a legfontosabb fordulat a kapcsolatban?',
        options: [
          { value: 'attention', icon: '👁', label: 'Figyeljen rám jobban.', hint: 'Újra érezd, hogy jelen vagy neki.' },
          { value: 'desire', icon: '♡', label: 'Kívánjon újra.', hint: 'Több vágyat és szenvedélyt szeretnél.' },
          { value: 'softness', icon: '🕯', label: 'Legyen lágyabb köztünk.', hint: 'Kevesebb feszültség, több melegség.' },
          { value: 'commit', icon: '∞', label: 'Erősebb kötődést szeretnék.', hint: 'Stabilabb, mélyebb kapcsolódást keresel.' },
        ],
      },
    ],
    stranger: [
      {
        key: 'situation',
        prompt: 'Honnan ismered azt, akit még alig ismersz?',
        options: [
          { value: 'online', icon: '📱', label: 'Online láttam / követem.', hint: 'Digitális térből indul a vonzalom.' },
          { value: 'work_school', icon: '🏛', label: 'Munkahelyen / suliban látom.', hint: 'Közös közeg, de kevés személyes kontakt.' },
          { value: 'public', icon: '✨', label: 'Csak párszor láttam.', hint: 'Még inkább érzés és benyomás szintjén van.' },
          { value: 'spiritual', icon: '☾', label: 'Inkább energetikailag érzem.', hint: 'Nincs igazi kapcsolat, de erős belső húzás van.' },
        ],
      },
      {
        key: 'pain',
        prompt: 'Mi a legnehezebb abban, hogy még alig ismered?',
        options: [
          { value: 'notice', icon: '👁', label: 'Azt szeretném, hogy észrevegyen.', hint: 'Még nincs igazi kapcsolódási pont.' },
          { value: 'approach', icon: '💬', label: 'Nem tudom, hogyan közeledjek.', hint: 'Félsz, hogy furcsa vagy túl direkt lenne.' },
          { value: 'fantasy', icon: '🌀', label: 'Túl sokat képzelek bele.', hint: 'Erős a vágy, de kevés a valós információ.' },
          { value: 'confidence', icon: '🌹', label: 'Nem érzem magam elég magabiztosnak.', hint: 'Szeretnél erősebben jelen lenni.' },
        ],
      },
      {
        key: 'pattern',
        prompt: 'Milyen első hatást szeretnél kelteni benne?',
        options: [
          { value: 'curiosity', icon: '?', label: 'Legyen kíváncsi rám.', hint: 'Akarjon többet tudni rólad.' },
          { value: 'dreamy', icon: '☾', label: 'Maradjak meg benne érzésként.', hint: 'Egy finom, emlékezetes lenyomatot szeretnél.' },
          { value: 'magnetic', icon: '✦', label: 'Érezzen vonzást.', hint: 'Ne erőltetetten, hanem természetesen.' },
          { value: 'signal', icon: '💫', label: 'Adjon valamilyen jelet.', hint: 'Egy pillantás, üzenet vagy apró közeledés is elég lenne.' },
        ],
      },
      {
        key: 'goal',
        prompt: 'Mit szeretnél elsőként megélni vele kapcsolatban?',
        options: [
          { value: 'notice_me', icon: '👁', label: 'Vegyen észre.', hint: 'Ne csak te figyeld őt.' },
          { value: 'message', icon: '💬', label: 'Írjon vagy reagáljon.', hint: 'Legyen valamilyen első kontakt.' },
          { value: 'meet', icon: '✦', label: 'Legyen alkalom találkozni.', hint: 'Nyíljon tér a valódi kapcsolódásra.' },
          { value: 'pull', icon: '♡', label: 'Érezzen húzást felém.', hint: 'Ne véletlen legyen, hanem vonzalmi tér.' },
        ],
      },
    ],
  };

  function normalizeEditableQuestion(block) {
    if (!block || typeof block !== 'object') return null;
    const rawOptions = Array.isArray(block.options) ? block.options : [];
    const containsPlaceholderContent = rawOptions.some((option) => {
      const label = String(option?.label || '').trim();
      const hint = String(option?.hint || '').trim();
      return /^\d+\.\s*válasz/i.test(label)
        || /^Rövid magyarázó alszöveg\.?/i.test(hint);
    });
    if (containsPlaceholderContent) return null;

    const options = rawOptions
      .filter((option) => option && String(option.label || '').trim())
      .map((option) => ({
        value: String(option.value || '').trim() || String(option.label || '').trim().toLowerCase().replace(/\s+/g, '_').slice(0, 40),
        icon: String(option.icon || '✦').trim(),
        label: String(option.label || '').trim(),
        hint: String(option.hint || '').trim(),
      }));
    if (!String(block.prompt || '').trim() || !String(block.key || '').trim() || options.length === 0) return null;
    return {
      key: String(block.key || '').trim(),
      prompt: String(block.prompt || '').trim(),
      order: Number(block.order || 0),
      allowCustom: block.allowCustom !== false && block.allowCustom !== 'false',
      customCopy: {
        label: String(block.customLabel || '').trim(),
        hint: String(block.customHint || '').trim(),
        placeholder: String(block.customPlaceholder || '').trim(),
      },
      options,
    };
  }

  function buildEditableQuestionMap(config = {}) {
    const map = { base: null, gender: {}, branches: {} };
    const blocks = Array.isArray(config.questionBlocks) ? config.questionBlocks : [];
    blocks.forEach((block) => {
      const question = normalizeEditableQuestion(block);
      if (!question) return;
      const scope = String(block.scope || '').trim();
      if (scope === 'base') {
        map.base = question;
        return;
      }
      if (scope === 'gender') {
        map.gender[question.key] = question;
        return;
      }
      if (!map.branches[scope]) map.branches[scope] = [];
      map.branches[scope].push(question);
    });
    Object.keys(map.branches).forEach((scope) => {
      map.branches[scope].sort((a, b) => Number(a.order || 0) - Number(b.order || 0));
    });
    return map;
  }

  function getQuestionsFor(answers = {}, config = {}) {
    const editable = buildEditableQuestionMap(config);
    const target = answers.target || '';
    const baseQuestion = editable.base || BASE_QUESTION;
    const genderQuestions = [
      editable.gender.userGender || GENDER_QUESTIONS[0],
      editable.gender.targetGender || GENDER_QUESTIONS[1],
    ].filter(Boolean);
    const branchQuestions = (editable.branches[target] && editable.branches[target].length)
      ? editable.branches[target]
      : (QUESTION_BRANCHES[target] || QUESTION_BRANCHES.ex);
    return [baseQuestion, ...genderQuestions, ...branchQuestions];
  }

  function getQuestion(index, answers = {}, config = {}) {
    return getQuestionsFor(answers, config)[index];
  }

  function shouldAddCustomOption(question) {
    if (!question || question.allowCustom === false) return false;
    return Boolean(question.customCopy || CUSTOM_OPTION_COPY[question.key]);
  }

  function getQuestionOptions(question) {
    const baseOptions = [...(question?.options || [])];
    if (!shouldAddCustomOption(question)) return baseOptions;
    const fallback = CUSTOM_OPTION_COPY[question.key] || {};
    const copy = question.customCopy || fallback;
    return [
      ...baseOptions,
      {
        value: 'custom',
        icon: '✍',
        label: copy.label || fallback.label || 'Más / saját válaszom van.',
        hint: copy.hint || fallback.hint || 'Írd le röviden a saját válaszodat.',
        custom: true,
        placeholder: copy.placeholder || fallback.placeholder || 'Írd le röviden...'
      },
    ];
  }

  function getQuestionLabel(question, value) {
    const option = getQuestionOptions(question).find((item) => item.value === value || item[0] === value);
    return option ? (option.label || option[1] || value) : value;
  }

  const sleep = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));
  const randomToken = () => `local_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;',
  }[character]));

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    document.body.classList.add('shift-ai-funnel-page');

    const configNode = root.querySelector('[data-shift-ai-config]');
    let config = {};
    try { config = JSON.parse(configNode?.textContent || '{}'); } catch (error) { console.error(error); }

    const body = root.querySelector('[data-chat-body]');
    const actions = root.querySelector('[data-chat-actions]');
    const progress = root.querySelector('[data-progress-bar]');
    const progressLabel = root.querySelector('[data-progress-label]');
    const progressCount = root.querySelector('[data-progress-count]');
    const progressStages = [...root.querySelectorAll('[data-progress-stages] span')];
    const toast = root.querySelector('[data-toast]');
    const privacyModal = root.querySelector('[data-privacy-modal]');

    const state = {
      step: 'welcome',
      questionIndex: 0,
      sessionToken: '',
      answers: {},
      customAnswers: {},
      story: '',
      followupQuestion: '',
      followupAnswer: '',
      teaser: '',
      assessment: null,
      email: '',
      marketingConsent: false,
      planToken: '',
      planUrl: '',
      purchasePending: false,
      offerTimerId: null,
      offerExpiresAt: 0,
    };

    function showToast(message, duration = 3200) {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(toast._timer);
      toast._timer = window.setTimeout(() => toast.classList.remove('is-visible'), duration);
    }

    function setProgress(percent) {
      const safePercent = Math.max(4, Math.min(100, percent));
      if (progress) progress.style.width = `${safePercent}%`;

      let label = 'Elemzés előkészítése';
      let count = '60 mp';
      if (safePercent >= 94) {
        label = 'Személyes indulópont kész';
        count = 'Kész';
      } else if (safePercent >= 82) {
        label = 'Személyes terved készül';
        count = 'Majdnem kész';
      } else if (safePercent >= 64) {
        label = 'Történeted pontosítása';
        count = 'Utolsó lépés';
      } else if (safePercent >= 34) {
        label = 'Helyzet feltárása';
        count = '2–3 perc';
      }
      if (progressLabel) progressLabel.textContent = label;
      if (progressCount) progressCount.textContent = count;

      const activeIndex = safePercent >= 82 ? 2 : safePercent >= 42 ? 1 : 0;
      progressStages.forEach((stage, index) => {
        stage.classList.toggle('is-active', index === activeIndex);
        stage.classList.toggle('is-complete', index < activeIndex);
      });
    }

    function scrollBottom() {
      window.requestAnimationFrame(() => {
        if (body) body.scrollTop = body.scrollHeight;
      });
    }

    function mentorMessage(html) {
      const wrapper = document.createElement('div');
      wrapper.className = 'saf-message saf-message--mentor';
      wrapper.innerHTML = `<div class="saf-message__avatar">S</div><div class="saf-bubble">${html}</div>`;
      body.appendChild(wrapper);
      scrollBottom();
      return wrapper;
    }

    function userMessage(text) {
      const wrapper = document.createElement('div');
      wrapper.className = 'saf-message saf-message--user';
      wrapper.innerHTML = `<div class="saf-bubble"><p>${escapeHtml(text)}</p></div>`;
      body.appendChild(wrapper);
      scrollBottom();
    }

    function typingMessage() {
      const wrapper = mentorMessage('<div class="saf-typing"><i></i><i></i><i></i></div>');
      return () => wrapper.remove();
    }

    function setActions(html) {
      actions.innerHTML = html;
      scrollBottom();
    }


    function getSelectedBook() {
      const books = config.books || {};
      const useExBook = state.answers.target === 'ex';
      const fallbackBook = {
        key: 'attract',
        title: config.mainTitle || 'Vond magadhoz ŐT',
        variantId: config.mainVariantId,
        available: config.mainAvailable,
        price: config.mainPrice,
        image: config.mainImage,
        label: config.mainTitle || 'Vond magadhoz ŐT',
      };
      const selected = useExBook ? (books.ex || fallbackBook) : (books.attract || fallbackBook);
      if (!selected || !Number(selected.variantId)) return fallbackBook;
      return selected;
    }

    function getSelectedBookLabel() {
      return state.answers.target === 'ex' ? 'VONZD VISSZA AZ EXED' : 'VOND MAGADHOZ ŐT';
    }

    function getTargetLabel() {
      const value = state.answers.target;
      if (value === 'ex') return 'ex';
      if (value === 'crush') return 'kiszemelt';
      if (value === 'partner') return 'párkapcsolat';
      if (value === 'stranger') return 'új vonzalom';
      return 'kapcsolódás';
    }

    function getGenderCopy() {
      const user = state.answers.userGender === 'female'
        ? 'nőként'
        : state.answers.userGender === 'male'
          ? 'férfiként'
          : '';

      const target = state.answers.targetGender === 'male'
        ? 'a férfi'
        : state.answers.targetGender === 'female'
          ? 'a nő'
          : 'ő';

      const targetAccusative = state.answers.targetGender === 'male'
        ? 'őt / a férfit'
        : state.answers.targetGender === 'female'
          ? 'őt / a nőt'
          : 'őt';

      return { user, target, targetAccusative };
    }

    function personalizePrompt(prompt) {
      if (!prompt) return '';
      const { user, target, targetAccusative } = getGenderCopy();
      return String(prompt)
        .replaceAll('{user}', user)
        .replaceAll('{target}', target)
        .replaceAll('{targetAccusative}', targetAccusative)
        .replace(/\s+/g, ' ')
        .trim();
    }

    function buildAnswersPayload() {
      return {
        ...state.answers,
        userGender: state.answers.userGender || 'prefer_not',
        targetGender: state.answers.targetGender || 'unknown',
        custom: {
          situation: state.customAnswers.situation || '',
          pain: state.customAnswers.pain || '',
          pattern: state.customAnswers.pattern || '',
          goal: state.customAnswers.goal || '',
        },
      };
    }

    function customAnswerFor(question) {
      return state.customAnswers?.[question?.key] || '';
    }

    function getOfferTotalText(book) {
      const bookPrice = String(book?.price || config.mainPrice || '').trim();
      const mentorPrice = String(config.mentorPrice || '').trim();
      if (!bookPrice || !mentorPrice) return config.totalToday || bookPrice || '';
      return `${bookPrice} + ${mentorPrice}/hó`;
    }

    function normalizeApiBase() {
      return String(config.apiBaseUrl || '').trim().replace(/\/$/, '');
    }

    async function apiRequest(path, payload) {
      const apiBase = normalizeApiBase();
      if (!apiBase) throw new Error('API_NOT_CONFIGURED');
      const response = await fetch(`${apiBase}${path}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload),
        mode: 'cors',
        credentials: 'omit',
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.error || `HTTP_${response.status}`);
      return data;
    }


    function buildPersonalPlanUrl(serverPlanUrl, planToken) {
      const desiredPath = String(config.personalPlanPath || '/pages/mentor').trim() || '/pages/mentor';
      const safePath = desiredPath.startsWith('/') ? desiredPath : `/${desiredPath}`;
      let url;
      try {
        url = new URL(safePath, window.location.origin);
      } catch (_) {
        url = new URL('/pages/mentor', window.location.origin);
      }

      // The uploaded theme uses /pages/mentor with the personal-plan alternate view.
      if (safePath.includes('/pages/mentor')) {
        url.searchParams.set('view', 'szemelyes-terv');
      }

      if (planToken) url.searchParams.set('plan', planToken);

      // Server URLs are accepted only when they point to an existing local page path.
      try {
        const fromServer = new URL(String(serverPlanUrl || ''), window.location.origin);
        if (fromServer.origin === window.location.origin) {
          if (!fromServer.searchParams.get('plan') && planToken) fromServer.searchParams.set('plan', planToken);
          return fromServer.toString();
        }
      } catch (_) {}

      return url.toString();
    }

    function collectAttribution() {
      const search = new URLSearchParams(window.location.search);
      return {
        landingUrl: window.location.href.slice(0, 1000),
        referrer: document.referrer.slice(0, 1000),
        utmSource: search.get('utm_source') || '',
        utmMedium: search.get('utm_medium') || '',
        utmCampaign: search.get('utm_campaign') || '',
        utmContent: search.get('utm_content') || '',
      };
    }

    async function startSession() {
      try {
        const data = await apiRequest('/api/funnel/start', {
          shopDomain: config.shopDomain,
          ...collectAttribution(),
        });
        state.sessionToken = data.sessionToken;
      } catch (error) {
        // Local placeholder so the chat UI can still run. The server has never
        // heard of it, so every later call would 404 -- ensureServerSession()
        // upgrades it as soon as the backend is reachable again.
        state.sessionToken = randomToken();
      }
      try { sessionStorage.setItem(STORAGE_KEY, state.sessionToken); } catch (_) {}
    }

    function hasServerSession() {
      return Boolean(state.sessionToken) && !String(state.sessionToken).startsWith('local_');
    }

    /**
     * Guarantees a real, server-issued session token before any call that
     * needs one.
     *
     * Without this a single transient failure at page load (a backend restart,
     * a dropped connection) poisons the whole funnel: the placeholder token is
     * kept for the rest of the visit and every followup/assessment/email call
     * fails with FUNNEL_SESSION_NOT_FOUND.
     */
    async function ensureServerSession() {
      if (hasServerSession()) return true;
      await startSession();
      return hasServerSession();
    }

    async function askQuestion(index) {
      const questions = getQuestionsFor(state.answers, config);
      const question = questions[index];
      if (!question) return askStory();
      state.questionIndex = index;
      state.step = `question_${index}`;
      const progressValue = 12 + Math.round((index / Math.max(1, questions.length)) * 44);
      setProgress(progressValue);
      const stopTyping = typingMessage();
      await sleep(index === 0 ? 500 : 360);
      stopTyping();
      mentorMessage(`<p>${escapeHtml(personalizePrompt(question.prompt))}</p>`);
      const questionOptions = getQuestionOptions(question);
      setActions(`<div class="saf-options saf-options--emoji">${questionOptions.map((option) => `
        <button type="button" class="saf-option saf-option--emoji ${option.custom ? 'saf-option--custom' : ''}" data-option-value="${escapeHtml(option.value)}">
          <span class="saf-option__emoji">${escapeHtml(option.icon || '✦')}</span>
          <span class="saf-option__text"><b>${escapeHtml(option.label)}</b>${option.hint ? `<small>${escapeHtml(option.hint)}</small>` : ''}</span>
          <span class="saf-option__arrow">›</span>
        </button>`).join('')}</div>`);
      actions.querySelectorAll('[data-option-value]').forEach((button) => {
        button.addEventListener('click', async () => {
          const value = button.dataset.optionValue;
          const selectedOption = questionOptions.find((option) => option.value === value);
          if (selectedOption?.custom) {
            await askCustomAnswer(index, question, selectedOption);
            return;
          }
          state.answers[question.key] = value;
          if (state.customAnswers[question.key]) state.customAnswers[question.key] = '';
          userMessage(getQuestionLabel(question, value));
          setActions('');
          await sleep(180);
          askQuestion(index + 1);
        }, { once: true });
      });
    }

    async function askCustomAnswer(index, question, option) {
      userMessage(option.label || 'Más / saját válaszom van.');
      setActions(`
        <div class="saf-custom-answer">
          <label class="saf-custom-answer__label">Írd le a saját válaszodat</label>
          <textarea class="saf-textarea" data-custom-answer maxlength="240" placeholder="${escapeHtml(option.placeholder || 'Írd le röviden...')}">${escapeHtml(customAnswerFor(question))}</textarea>
          <div class="saf-input-meta"><span>Röviden, saját szavaiddal</span><span data-char-count>${customAnswerFor(question).length} / 240</span></div>
          <button type="button" class="saf-primary-button saf-text-submit" data-custom-submit disabled>Tovább <span>→</span></button>
        </div>
      `);
      const input = actions.querySelector('[data-custom-answer]');
      const submit = actions.querySelector('[data-custom-submit]');
      const counter = actions.querySelector('[data-char-count]');
      input?.focus();
      const refresh = () => {
        const value = input.value.trim();
        counter.textContent = `${input.value.length} / 240`;
        submit.disabled = value.length < 3;
      };
      input.addEventListener('input', refresh);
      refresh();
      submit.addEventListener('click', async () => {
        const customValue = input.value.trim().slice(0, 240);
        state.answers[question.key] = 'custom';
        state.customAnswers[question.key] = customValue;
        userMessage(customValue);
        setActions('');
        await sleep(180);
        askQuestion(index + 1);
      }, { once: true });
    }

    function getStoryPlaceholder() {
      const target = state.answers.target;
      if (target === 'ex') return 'Például: szakítottunk, azóta hideg lett, de néha még ad jeleket. Nem tudom, írjak-e neki vagy várjak…';
      if (target === 'crush') return 'Például: egy közegben mozgunk, néha beszélünk, de nem tudom, hogyan érjem el, hogy másképp nézzen rám…';
      if (target === 'partner') return 'Például: együtt vagyunk, de eltávolodtunk, kevesebb a vágy vagy a figyelem, és szeretném újra felébreszteni köztünk…';
      return 'Például: alig ismerem, de erős a vonzalom, szeretném, hogy észrevegyen vagy legyen alkalom közelebb kerülni…';
    }

    async function askStory() {
      state.step = 'story';
      setProgress(64);
      const stopTyping = typingMessage();
      await sleep(420);
      stopTyping();
      mentorMessage(`<p><strong>${escapeHtml(config.copy?.storyMentorTitle || 'Most már látom, melyik irányba érdemes tovább kérdeznem.')}</strong></p><p>${escapeHtml(config.copy?.storyMentorBody || 'Ahhoz, hogy ne sablonválaszt adjak, meséld el röviden a saját szavaiddal, mi történt vagy mit szeretnél elérni vele. Ne írj teljes nevet vagy más azonosító adatot.')}</p>`);
      setActions(`
        <textarea class="saf-textarea" data-story-input maxlength="1200" placeholder="${escapeHtml(getStoryPlaceholder())}"></textarea>
        <div class="saf-input-meta"><span>Legalább 40 karakter</span><span data-char-count>0 / 1200</span></div>
        <button type="button" class="saf-primary-button saf-text-submit" data-story-submit disabled>Elküldöm a történetemet <span>→</span></button>
      `);
      const input = actions.querySelector('[data-story-input]');
      const submit = actions.querySelector('[data-story-submit]');
      const counter = actions.querySelector('[data-char-count]');
      input.focus();
      input.addEventListener('input', () => {
        const length = input.value.trim().length;
        counter.textContent = `${input.value.length} / 1200`;
        submit.disabled = length < 40;
      });
      submit.addEventListener('click', async () => {
        state.story = input.value.trim();
        userMessage(state.story);
        setActions('');
        await generateFollowup();
      }, { once: true });
    }

    function fallbackFollowup() {
      const target = state.answers.target;
      const situation = state.answers.situation;
      const pain = state.answers.pain;
      if (target === 'ex') {
        if (situation === 'blocked') return 'A tiltás vagy távolság óta próbáltad más módon elérni, vagy teljesen megálltál?';
        if (situation === 'third_party') return 'A másik személy jelenléte biztos információ, vagy inkább jelekből és félelemből gondolod?';
        if (situation === 'mixed_signals') return 'Mi volt a legutóbbi konkrét jel, amit közeledésnek éreztél?';
        return 'Mi volt az utolsó pillanat köztetek, ami után úgy érezted, hogy minden megváltozott?';
      }
      if (target === 'crush') {
        if (pain === 'notice') return 'Hol és mikor találkozol vele leggyakrabban, ahol észrevehetne?';
        if (pain === 'fear') return 'Mi az, amitől a legjobban félsz, ha közelednél felé?';
        return 'Mi volt az a jel vagy pillanat, ami miatt elkezdtél reménykedni benne?';
      }
      if (target === 'partner') {
        if (pain === 'desire') return 'Mikor érezted utoljára igazán azt, hogy megvolt köztetek a vágy vagy a szikra?';
        if (pain === 'security') return 'Mi az, amitől most kevésbé érzed magad biztonságban mellette?';
        return 'Mi az, amit most leginkább hiányolsz a kapcsolatotokból?';
      }
      if (target === 'stranger') {
        if (pain === 'fantasy') return 'Mi az, amit valójában tudsz róla, és mi az, amit inkább elképzeltél?';
        return 'Mi az első dolog, ami miatt úgy érezted, hogy szeretnéd közelebb hozni magadhoz?';
      }
      return 'Mi az első dolog, ami miatt úgy érezted, hogy szeretnéd közelebb hozni magadhoz?';
    }

    async function generateFollowup() {
      state.step = 'followup_loading';
      setProgress(72);
      const stopTyping = typingMessage();
      await sleep(520);
      try {
        await ensureServerSession();
        const data = await apiRequest('/api/funnel/followup', {
          sessionToken: state.sessionToken,
          answers: buildAnswersPayload(),
          story: state.story,
        });
        state.followupQuestion = data.followupQuestion || fallbackFollowup();
        state.teaser = data.teaser || '';
      } catch (error) {
        state.followupQuestion = fallbackFollowup();
      }
      stopTyping();
      mentorMessage(`<p><strong>Köszönöm, hogy ezt elmondtad.</strong></p><p>${escapeHtml(state.followupQuestion)}</p>`);
      setActions(`
        <textarea class="saf-textarea" data-followup-input maxlength="700" placeholder="Írd le röviden…"></textarea>
        <div class="saf-input-meta"><span>Ez az utolsó kérdésem</span><span data-char-count>0 / 700</span></div>
        <button type="button" class="saf-primary-button saf-text-submit" data-followup-submit disabled>Válaszolok <span>→</span></button>
      `);
      const input = actions.querySelector('[data-followup-input]');
      const submit = actions.querySelector('[data-followup-submit]');
      const counter = actions.querySelector('[data-char-count]');
      input.focus();
      input.addEventListener('input', () => {
        const length = input.value.trim().length;
        counter.textContent = `${input.value.length} / 700`;
        submit.disabled = length < 5;
      });
      submit.addEventListener('click', async () => {
        state.followupAnswer = input.value.trim();
        userMessage(state.followupAnswer);
        setActions('');
        await generateAssessment();
      }, { once: true });
    }

    function fallbackAssessment() {
      const target = state.answers.target;
      const pain = state.answers.pain;
      const pattern = state.answers.pattern;
      const situation = state.answers.situation;

      if (target === 'ex') {
        const blocks = {
          waiting: ['A várakozás és a csend értelmezése irányít', 'A mostani bizonytalanság miatt minden apró jel túl nagy jelentőséget kap.'],
          mind_loop: ['Túl sok gondolati energia forog körülötte', 'A fókuszod újra és újra rá kerül, ezért nehéz visszavenni a saját középpontodat.'],
          fear_loss: ['A veszteségtől való félelem sürget', 'A félelem könnyen pánikból indított lépések felé tolna.'],
          worth: ['A választottság érzése sérült', 'Nem csak ő hiányzik, hanem az is, hogy újra fontosnak érezd magad.'],
        };
        const selected = blocks[pain] || blocks.waiting;
        const avoid = pattern === 'write'
          ? 'Ne küldj hosszú, érzelmi üzenetet csak azért, hogy azonnali megnyugvást kapj.'
          : situation === 'blocked'
            ? 'Ne próbáld megkerülni a távolságot vagy tiltást más csatornán.'
            : 'Ne figyeld minden mozdulatát úgy, mintha abból azonnal választ kellene kapnod.';
        return {
          patternTitle: selected[0],
          openingInsight: selected[1],
          mainBlock: 'A fő blokk most az, hogy a visszavonzási vágy összekeveredik az azonnali kontroll visszaszerzésének igényével.',
          firstStep: 'A következő 24 órában először állítsd vissza a saját fókuszodat, és csak ezután dönts bármilyen kapcsolatfelvételről.',
          avoidToday: avoid,
          recommendedReason: 'A válaszaid alapján számodra a VONZD VISSZA AZ EXED útvonal adja a legerősebb kiindulópontot: lezáratlan kötődés, hiányérzet és visszavonzási fókusz egyszerre van jelen.',
          mentorOpening: 'Az első napon abban segítek, hogy a csendet ne végleges ítéletként értelmezd, és ne az impulzus vezesse a következő lépésedet.',
          salesSuppressed: false,
        };
      }

      if (target === 'partner') {
        return {
          patternTitle: 'A kapcsolódás újraébresztése a fő minta',
          openingInsight: 'Nálad nem ex-visszavonzásról van szó, hanem arról, hogyan lehet újra figyelmet, vágyat és érzelmi jelenlétet építeni egy meglévő kapcsolatban.',
          mainBlock: 'A kapcsolatban most a megszokás, sértettség vagy figyelemhiány könnyen elviszi a fókuszt a valódi kapcsolódásról.',
          firstStep: 'Az első lépésed az, hogy ne követelésből kérj reakciót, hanem olyan teret építs, amelyben újra jó érzés közelebb lépni.',
          avoidToday: 'Ne próbáld erőből bizonyítani, hogy több figyelmet érdemelsz.',
          recommendedReason: 'A válaszaid alapján a VOND MAGADHOZ ŐT útvonal illik hozzád, párkapcsolati vágy- és kapcsolódásfókusszal.',
          mentorOpening: 'Az első napon abban segítek, hogy visszahozd a saját vonzerődet és ne a hiányból kommunikálj.',
          salesSuppressed: false,
        };
      }

      if (target === 'crush') {
        return {
          patternTitle: 'Az első vonzalmi tér felépítése a fő minta',
          openingInsight: 'Nálad nem visszavonzásról van szó, hanem arról, hogyan válj észrevehetőbbé, kíváncsibbá és könnyebben megközelíthetővé anélkül, hogy erőltetnéd.',
          mainBlock: 'A fő blokk most a bizonytalanság: szeretnél hatni rá, de nem akarod túl direktnek vagy kínosnak érezni magad.',
          firstStep: 'Az első lépésed az, hogy finom, magabiztos jelenlétet építs, ne pedig azonnali reakciót próbálj kikényszeríteni.',
          avoidToday: 'Ne ugorj túl gyorsan vallomásba vagy túl erős kezdeményezésbe.',
          recommendedReason: 'A válaszaid alapján a VOND MAGADHOZ ŐT útvonal illik hozzád, kiszemeltre szabott vonzalomépítéssel.',
          mentorOpening: 'Az első napon abban segítek, hogy tisztább fókuszból és erősebb jelenlétből indulj.',
          salesSuppressed: false,
        };
      }

      return {
        patternTitle: 'Az első kapcsolódási tér megnyitása a fő minta',
        openingInsight: 'Nálad a vonzalom még kevés valós kontaktból indul, ezért fontos, hogy a fantázia helyett magabiztos, észrevehető jelenlétet építs.',
        mainBlock: 'A fő blokk most az, hogy erős a belső húzás, de még kevés a valódi kapcsolódási pont.',
        firstStep: 'Az első lépésed az, hogy olyan helyzetet és jelenlétet teremts, ahol egy első jel vagy kontakt természetesebben megszülethet.',
        avoidToday: 'Ne építs túl nagy történetet valakiről, akiről még kevés valós információd van.',
        recommendedReason: 'A válaszaid alapján a VOND MAGADHOZ ŐT útvonal illik hozzád, új vonzalomra és első kapcsolódási térre szabva.',
        mentorOpening: 'Az első napon abban segítek, hogy stabilabb, tisztább jelenlétből közelíts ehhez a vonzalomhoz.',
        salesSuppressed: false,
      };
    }

    async function generateAssessment() {
      state.step = 'assessment_loading';
      setProgress(82);
      const stopTyping = typingMessage();
      mentorMessage('<p>Összerakom a válaszaidból a személyes kiindulópontodat…</p>');
      await sleep(900);
      try {
        await ensureServerSession();
        const data = await apiRequest('/api/funnel/assessment', {
          sessionToken: state.sessionToken,
          answers: buildAnswersPayload(),
          story: state.story,
          followupQuestion: state.followupQuestion,
          followupAnswer: state.followupAnswer,
        });
        state.assessment = data.assessment || fallbackAssessment();
      } catch (error) {
        state.assessment = fallbackAssessment();
      }
      stopTyping();
      setProgress(88);
      if (state.assessment.salesSuppressed) return showSafetyResult();
      mentorMessage(`<p><strong>Amit a történetedből először látok:</strong></p><p>${escapeHtml(state.assessment.openingInsight)}</p>`);
      await sleep(280);
      askEmail();
    }

    function askEmail() {
      state.step = 'email';
      mentorMessage('<p>Elkészült a teljes személyes kiindulópontod. Add meg az e-mail-címedet, hogy elmentsem és innen folytathassuk.</p>');
      setActions(`
        <form class="saf-email-form" data-email-form novalidate>
          <input class="saf-email-input" type="email" autocomplete="email" placeholder="E-mail-címed" required data-email-input>
          <label class="saf-checkbox"><input type="checkbox" required data-analysis-consent><span>Hozzájárulok, hogy a válaszaimat a személyes elemzésemhez és – vásárlás esetén – a Mentor-folytonossághoz tárolják.</span></label>
          <label class="saf-checkbox"><input type="checkbox" data-marketing-consent><span>Szeretnék hasznos emlékeztetőket és ajánlatokat kapni e-mailben. Ez opcionális.</span></label>
          <div class="saf-inline-error" data-email-error hidden></div>
          <button type="submit" class="saf-primary-button">Megnézem a személyes tervemet <span>→</span></button>
        </form>
      `);
      const form = actions.querySelector('[data-email-form]');
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const email = actions.querySelector('[data-email-input]').value.trim().toLowerCase();
        const analysisConsent = actions.querySelector('[data-analysis-consent]').checked;
        const marketingConsent = actions.querySelector('[data-marketing-consent]').checked;
        const errorBox = actions.querySelector('[data-email-error]');
        if (!/^\S+@\S+\.\S+$/.test(email)) {
          errorBox.hidden = false; errorBox.textContent = 'Adj meg egy érvényes e-mail-címet.'; return;
        }
        if (!analysisConsent) {
          errorBox.hidden = false; errorBox.textContent = 'A személyes elemzés elmentéséhez szükség van a hozzájárulásodra.'; return;
        }
        const button = form.querySelector('button');
        button.disabled = true; button.firstChild.textContent = 'Mentés… ';
        state.email = email;
        state.marketingConsent = marketingConsent;
        try {
          await ensureServerSession();
          const emailResult = await apiRequest('/api/funnel/email', {
            sessionToken: state.sessionToken,
            email,
            analysisConsent,
            marketingConsent,
          });
          state.planToken = String(emailResult.planToken || '');
          state.planUrl = buildPersonalPlanUrl(emailResult.planUrl, state.planToken);
        } catch (error) {
          errorBox.hidden = false;
          errorBox.textContent = 'Most nem sikerült biztonságosan elmenteni a személyes tervedet. Próbáld újra.';
          button.disabled = false;
          button.firstChild.textContent = 'Megnézem a személyes tervemet ';
          return;
        }
        userMessage(email);
        setActions('');
        await sleep(260);
        showAssessment();
      });
    }

    function showAssessment() {
      state.step = 'result';
      setProgress(94);
      const assessment = state.assessment || fallbackAssessment();
      mentorMessage(`<p class="saf-message-label">A személyes kiindulópontod</p><p><strong>${escapeHtml(assessment.patternTitle)}</strong></p><p>${escapeHtml(assessment.openingInsight)}</p>`);
      window.setTimeout(() => {
        mentorMessage(`<div class="saf-insight-list"><div><span>01</span><p><b>A fő blokk most</b>${escapeHtml(assessment.mainBlock)}</p></div><div><span>02</span><p><b>Az első lépésed</b>${escapeHtml(assessment.firstStep)}</p></div><div><span>03</span><p><b>Amit ma kerülj</b>${escapeHtml(assessment.avoidToday)}</p></div></div>`);
      }, 260);
      window.setTimeout(showPlanInvitation, 760);
    }


    function showPlanInvitation() {
      state.step = 'plan_invitation';
      setProgress(100);
      const assessment = state.assessment || fallbackAssessment();
      mentorMessage(`<p><strong>A válaszaid alapján elkészítettem azt a 7 napos irányt, amely a te helyzetedhez kapcsolódik.</strong></p><p>${escapeHtml(assessment.recommendedReason)}</p>`);
      setActions(`
        <div class="saf-purchase-panel saf-plan-invitation">
          <div class="saf-session-saved"><span>✓</span><p><b>A személyes kiindulópontod elkészült.</b> A következő oldalon megnézheted, pontosan mit tartalmazna a neked összeállított program.</p></div>
          <button type="button" class="saf-primary-button saf-purchase-main" data-open-personal-plan>
            <span>Megnézem a személyes tervemet</span><small>Még nem köteleződsz el semmi mellett</small>
          </button>
          <div class="saf-purchase-trust"><span>Személyes összefoglaló</span><span>Átlátható árak</span><span>Biztonságos Shopify fizetés</span></div>
          <p class="saf-subscription-note">A következő oldalon minden részletet, az egyszeri programdíjat és a Mentor havi díját is egyértelműen látni fogod.</p>
        </div>
      `);
      const openButton = actions.querySelector('[data-open-personal-plan]');
      openButton?.addEventListener('click', async () => {
        if (!state.planToken) {
          showToast('A személyes terv linkje még nem készült el. Próbáld újra az e-mail mentését.');
          return;
        }
        openButton.disabled = true;
        openButton.querySelector('span').textContent = 'Megnyitjuk a személyes tervedet…';
        try {
          await apiRequest('/api/funnel/event', {
            sessionToken: state.sessionToken,
            eventType: 'personal_plan_clicked',
            metadata: { email: state.email },
          });
        } catch (_) {}
        if (state.planUrl) {
          window.location.assign(state.planUrl);
          return;
        }
        const path = String(config.personalPlanPath || '/pages/mentor').trim() || '/pages/mentor';
        const safePath = path.startsWith('/') ? path : `/${path}`;
        const url = new URL(safePath, window.location.origin);
        if (url.pathname === '/pages/mentor') url.searchParams.set('view', 'szemelyes-terv');
        url.searchParams.set('plan', state.planToken);
        window.location.assign(url.toString());
      });
      scrollBottom();
    }

    function offerExpiryTimestamp() {
      const minutes = Math.max(5, Math.min(30, Number(config.offerCountdownMinutes || 15)));
      let expiry = 0;
      try { expiry = Number(sessionStorage.getItem(OFFER_EXPIRY_KEY) || 0); } catch (_) {}
      if (!expiry) {
        expiry = Date.now() + (minutes * 60 * 1000);
        try { sessionStorage.setItem(OFFER_EXPIRY_KEY, String(expiry)); } catch (_) {}
      }
      return expiry;
    }

    function formatCountdown(ms) {
      const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }

    function startOfferCountdown(container) {
      const output = container.querySelector('[data-offer-countdown]');
      const addonButton = container.querySelector('[data-buy-addon]');
      const timerShell = container.querySelector('[data-offer-timer]');
      if (!output || !addonButton) return;
      state.offerExpiresAt = offerExpiryTimestamp();
      window.clearInterval(state.offerTimerId);
      const tick = () => {
        const remaining = state.offerExpiresAt - Date.now();
        output.textContent = formatCountdown(remaining);
        if (remaining <= 0) {
          window.clearInterval(state.offerTimerId);
          addonButton.disabled = true;
          addonButton.innerHTML = '<span>Az időablak lezárult</span><small>A program gyorsítás nélkül továbbra is elérhető</small>';
          timerShell?.classList.add('is-expired');
        }
      };
      tick();
      state.offerTimerId = window.setInterval(tick, 1000);
    }

    function showOffer() {
      state.step = 'offer';
      setProgress(100);
      const assessment = state.assessment || fallbackAssessment();
      const book = getSelectedBook();
      const bookLabel = getSelectedBookLabel();
      const targetLabel = getTargetLabel();
      mentorMessage(`<p><strong>A válaszaid alapján ezt az irányt ajánlom: ${escapeHtml(bookLabel)}.</strong></p><p>${escapeHtml(assessment.recommendedReason)}</p>`);
      const image = book.image
        ? `<img class="saf-product-message__image" src="${escapeHtml(book.image)}" alt="${escapeHtml(book.title || bookLabel)}" loading="lazy">`
        : '<div class="saf-product-message__fallback">THE<br>LOVE<br>METHOD</div>';
      const offer = mentorMessage(`
        <div class="saf-product-message">
          <div class="saf-product-message__media">${image}</div>
          <div class="saf-product-message__content">
            <div class="saf-product-message__eyebrow">A személyes programod</div>
            <h3>${escapeHtml(book.title || bookLabel)}</h3>
            <p>${escapeHtml(assessment.mentorOpening)}</p>
            <div class="saf-product-message__benefits">
              <span>Interaktív e-book feladatokkal</span>
              <span>The Shift Journal ajándék</span>
              <span>Személyes Mentor + 30 havi kredit</span>
            </div>
            <div class="saf-product-message__price">
              <div><small>Ajánlott e-book</small><strong>${escapeHtml(book.price || config.mainPrice || '')}</strong></div>
              <p>${escapeHtml(bookLabel)}<br>+ ${escapeHtml(config.mentorPrice || '')}/hó Mentor</p>
            </div>
          </div>
        </div>
      `);
      offer.classList.add('saf-message--product');
      setActions(`
        <div class="saf-purchase-panel">
          <div class="saf-session-saved"><span>✓</span><p><b>A történeted mentve van.</b> Fizetés után e-mailben kapod meg a belépést, a Mentor pedig innen folytatja.</p></div>
          <button type="button" class="saf-primary-button saf-purchase-main" data-buy-base>
            <span>Elindítom a személyes útvonalamat</span><small>${escapeHtml(bookLabel)} · ${escapeHtml(getOfferTotalText(book))}</small>
          </button>
          <button type="button" class="saf-addon-button" data-buy-addon>
            <span><b>+ 24 órás gyorsítás</b><small>Intenzívebb első nap · ${escapeHtml(config.addonPrice || '')}</small></span><i>Hozzáadom</i>
          </button>
          <div class="saf-offer-timer" data-offer-timer><span>Az opcionális gyorsítás ebben a sessionben még</span><strong data-offer-countdown>15:00</strong></div>
          <div class="saf-purchase-trust"><span>Shopify fizetés</span><span>Azonnali e-mail</span><span>Bármikor lemondható</span></div>
          <button type="button" class="saf-secondary-link" data-offer-details>Mi történik pontosan a vásárlás után?</button>
          <p class="saf-subscription-note">A Mentor-előfizetés 30 naponta megújul. Bármikor lemondható. A program nem ígér garantált eredményt vagy kontrollt egy másik ember felett.</p>
        </div>
      `);
      const baseButton = actions.querySelector('[data-buy-base]');
      const addonButton = actions.querySelector('[data-buy-addon]');
      const detailButton = actions.querySelector('[data-offer-details]');
      baseButton?.addEventListener('click', () => addFunnelToCart(false, baseButton));
      addonButton?.addEventListener('click', () => addFunnelToCart(true, addonButton));
      detailButton?.addEventListener('click', () => {
        mentorMessage('<p><strong>A fizetés után néhány percen belül e-mailben megkapod a személyes platformod aktiváló linkjét.</strong></p><p>A rendeléshez ezt a beszélgetést kapcsoljuk, ezért a Mentor emlékezni fog a kiindulópontodra. Nem kell újra elmesélned mindent: belépés után az első nappal folytatjátok.</p>');
      });
      startOfferCountdown(actions);
      scrollBottom();
    }

    function showSafetyResult() {
      state.step = 'safety';
      setProgress(100);
      const message = state.assessment?.safetyMessage || 'Amit leírtál, most fontosabb annál, hogy egy értékesítési ajánlattal folytassam. Kérlek, fordulj egy megbízható közeli emberhez vagy megfelelő szakmai segítséghez. Ha közvetlen veszélyben vagy, hívd a 112-t.';
      mentorMessage(`<p class="saf-message-label">Most a biztonság az első</p><p><strong>Nem kell egyedül maradnod ezzel.</strong></p><p>${escapeHtml(message)}</p>`);
      setActions('');
    }

    function closeModal(modal) {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    async function addFunnelToCart(includeAddon, triggerButton) {
      if (state.purchasePending) return;
      const button = triggerButton;
      if (!button) return;
      const book = getSelectedBook();
      if (!book.available || !Number(book.variantId)) {
        showToast('Az ajánlott e-book jelenleg nem elérhető.'); return;
      }
      if (!config.mentorAvailable || !Number(config.mentorVariantId) || !Number(config.sellingPlanId)) {
        showToast('A Mentor-előfizetés beállítása még nem teljes.'); return;
      }
      if (includeAddon && (!config.addonAvailable || !Number(config.addonVariantId))) {
        showToast('A 24 órás gyorsítás jelenleg nem elérhető.'); return;
      }
      state.purchasePending = true;
      const original = button.innerHTML;
      button.disabled = true;
      button.textContent = config.copy?.loading || 'Előkészítjük a fizetést…';
      const sessionProperty = String(state.sessionToken || randomToken()).slice(0, 250);
      const properties = {
        _shift_session_id: sessionProperty,
        _shift_funnel: 'ai-mentor',
        _shift_target: String(state.answers.target || ''),
        _shift_user_gender: String(state.answers.userGender || 'prefer_not'),
        _shift_target_gender: String(state.answers.targetGender || 'unknown'),
        _shift_recommended_book: getSelectedBookLabel(),
      };
      const items = [
        { id: Number(book.variantId), quantity: 1, properties },
        { id: Number(config.mentorVariantId), quantity: 1, selling_plan: Number(config.sellingPlanId), properties },
      ];
      if (config.giftAvailable && Number(config.giftVariantId)) items.push({ id: Number(config.giftVariantId), quantity: 1, properties: { _shift_gift: 'journal', _shift_session_id: sessionProperty } });
      if (includeAddon && config.addonAvailable && Number(config.addonVariantId)) items.push({ id: Number(config.addonVariantId), quantity: 1, properties: { _shift_addon: '24-hour', _shift_session_id: sessionProperty } });

      const routeRoot = (window.Shopify?.routes?.root || config.cartRoot || '/').replace(/\/?$/, '/');
      try {
        const response = await fetch(`${routeRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'CART_ADD_FAILED');
        try {
          await apiRequest('/api/funnel/event', {
            sessionToken: state.sessionToken,
            eventType: 'checkout_started',
            metadata: { includeAddon, email: state.email },
          });
        } catch (_) {}
        window.location.assign(`${routeRoot}checkout`);
      } catch (error) {
        console.error('Shift AI funnel cart error', error);
        showToast(config.copy?.cartError || 'Nem sikerült megnyitni a fizetést.');
        button.disabled = false;
        button.innerHTML = original;
        state.purchasePending = false;
      }
    }

    function resetFunnel() {
      if (!window.confirm('Biztosan újrakezded a személyes elemzést?')) return;
      try { sessionStorage.removeItem(STORAGE_KEY); sessionStorage.removeItem(OFFER_EXPIRY_KEY); } catch (_) {}
      window.location.reload();
    }

    root.querySelector('[data-funnel-start]')?.addEventListener('click', async () => {
      state.step = 'starting';
      setActions('<button class="saf-primary-button" type="button" disabled>Kapcsolódás a Mentorhoz…</button>');
      await startSession();
      userMessage('Elmondom, mi történt.');
      await sleep(220);
      mentorMessage(`<p><strong>${escapeHtml(config.copy?.startMentorTitle || 'Rendben. Először tisztázzuk, kit szeretnél bevonzani.')}</strong></p><p>${escapeHtml(config.copy?.startMentorBody || 'Az első válasz alapján választom ki, hogy a VONZD VISSZA AZ EXED vagy a VOND MAGADHOZ ŐT útvonal illik hozzád. Utána finoman személyre szabom a megszólítást is.')}</p>`);
      await sleep(260);
      askQuestion(0);
    }, { once: true });

    root.querySelector('[data-funnel-reset]')?.addEventListener('click', resetFunnel);
    root.querySelector('[data-privacy-open]')?.addEventListener('click', () => {
      privacyModal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    });
    root.querySelectorAll('[data-privacy-close]').forEach((element) => element.addEventListener('click', () => closeModal(privacyModal)));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        if (!privacyModal.hidden) closeModal(privacyModal);
      }
    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
